"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var withStyles_1 = require("../decorators/withStyles");

var Tooltip_styles_1 = require("./Tooltip.styles");

var modsClassName_1 = require("../assets/modsClassName");

var classNames = require("classnames");

var Overlay_1 = require("../utils/Overlay");

var HiddenResponsive_1 = require("../HiddenResponsive/HiddenResponsive");

var baseProps_1 = require("../assets/baseProps");

var checkTimeout = 100;
var mountedTooltips = [];

var Tooltip =
/** @class */
function (_super) {
  __extends(Tooltip, _super);

  function Tooltip() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      visible: false
    };

    _this.onMouseEnter = function () {
      return _this.showOverlay();
    };

    _this.onMouseLeave = function () {
      return _this.hideOverlay();
    };

    _this.getInnerElement = function (updateSize) {
      var props = _this.props;
      var overlay = props.overlay,
          classes = props.classes;

      if (typeof overlay === 'function') {
        return overlay(updateSize);
      }

      return React.createElement("div", {
        className: classes.overlayContent
      }, overlay);
    };

    _this.getOverlay = function () {
      var _a = _this,
          props = _a.props,
          visible = _a.visible;

      if (!visible) {
        return null;
      }

      var overlayContainer = props.overlayContainer,
          placement = props.placement,
          reservePlacement = props.reservePlacement,
          arrow = props.arrow,
          testId = props.testId,
          onlyDesktop = props.onlyDesktop;
      var overlay = React.createElement(Overlay_1.default, {
        container: overlayContainer,
        placement: placement,
        reservePlacement: reservePlacement,
        underlayElement: _this.underlay,
        children: _this.getInnerElement,
        arrow: arrow,
        testId: testId,
        mode: 'tooltip'
      });

      if (onlyDesktop) {
        return React.createElement(HiddenResponsive_1.default, {
          type: "mobile"
        }, overlay);
      }

      return overlay;
    };

    return _this;
  }

  Object.defineProperty(Tooltip.prototype, "isMouseInside", {
    get: function get() {
      var wrapper = this.wrapper;
      return wrapper && wrapper.matches(':hover');
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Tooltip.prototype, "visible", {
    get: function get() {
      var _a = this,
          state = _a.state,
          props = _a.props;

      switch (props.visible) {
        case true:
          return true;

        case false:
          return false;

        default:
          return state.visible;
      }
    },
    enumerable: true,
    configurable: true
  });

  Tooltip.prototype.checkMouse = function () {
    var _this = this;

    this.checkTimeout = window.setTimeout(function () {
      var isMouseInside = _this.isMouseInside;

      if (!isMouseInside) {
        _this.hideOverlay();

        return;
      }

      _this.checkMouse();
    }, checkTimeout);
  };

  Tooltip.prototype.showOverlay = function () {
    var _this = this; // Скрываем все тултипы


    mountedTooltips.forEach(function (tooltip) {
      if (tooltip === _this) {
        return;
      }

      tooltip.hideOverlay(true);
    });
    this.clearLeaveTimeout();
    this.setState({
      visible: true
    });
    this.checkMouse();
  };

  Tooltip.prototype.hideOverlay = function (force) {
    var _this = this;

    if (force === void 0) {
      force = false;
    }

    if (!this.state.visible) {
      // Не прячем если и так не спрятано
      return;
    }

    var delay = this.props.delay;

    if (force || !delay) {
      this.setState({
        visible: false
      });
    }

    if (this.leaveTimeout) {
      // Закрываем по старому таймауту если скрытие уже запущено
      return;
    }

    this.leaveTimeout = window.setTimeout(function () {
      _this.leaveTimeout = null;

      _this.hideOverlay(true);
    }, delay);
  };

  Tooltip.prototype.clearLeaveTimeout = function () {
    if (this.leaveTimeout) {
      clearTimeout(this.leaveTimeout);
      this.leaveTimeout = null;
    }
  };

  Tooltip.prototype.componentDidMount = function () {
    mountedTooltips.push(this);
    this.forceUpdate();
  };

  Tooltip.prototype.componentWillUnmount = function () {
    if (this.checkTimeout) {
      clearTimeout(this.checkTimeout);
    }

    mountedTooltips.splice(mountedTooltips.indexOf(this), 1);
  };

  Tooltip.prototype.render = function () {
    var _this = this;

    var _a = this,
        props = _a.props,
        onMouseEnter = _a.onMouseEnter,
        onMouseLeave = _a.onMouseLeave;

    var children = props.children,
        classes = props.classes;
    return React.createElement("div", __assign({}, baseProps_1.default(props), {
      ref: function ref(element) {
        return _this.wrapper = element;
      },
      className: classNames(classes.tooltip, modsClassName_1.modsClassName(this.props, 'inline')),
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    }), React.createElement("div", {
      ref: function ref(element) {
        return _this.underlay = element;
      }
    }, children), this.getOverlay());
  };

  Tooltip.defaultProps = {
    placement: 'bottom'
  };
  Tooltip = __decorate([withStyles_1.withStyles(Tooltip_styles_1.tooltipStyles)], Tooltip);
  return Tooltip;
}(React.PureComponent);

exports.default = Tooltip;